<template>
  <button class="btn" @click="toActiveAudio()">
    <LockCircleIcon class="btn__icon" v-if="!hasPaidAccount"/>
    <PlaybackStatus
      class="btn__play"
      :class="!isLoadingTheAudio && 'btn__play--hover'"
      :color="'white'"
      :isLoading="isLoadingTheAudio"
      :isPlaying="isTheAudioPlaying"
      :speed="speed"
      :scale="1.4"
      v-else 
    />
  </button>
</template>

<script setup>
  import { watch, ref, onBeforeUnmount, computed, nextTick } from 'vue';
  import { useStore } from 'vuex';
  import { useUserAuth } from '@/Groups/Audioplayer/private/imports/externalStoreData';
  import { useAudioControl } from '@/Groups/Audioplayer/private/composables/audioControl';
  import { useAudioPlayerState } from '@/Groups/Audioplayer/private/composables/computedValues';
  import { Props } from './props';
  //---------------------------------
  import PlaybackStatus from '@/Groups/Audioplayer/private/ui/PlaybackStatus/PlaybackStatus.vue';
  import { LockCircleIcon } from "@/Groups/Audioplayer/private/imports/externalTemplates";
  //---------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //---------------------------------
  const isReady = ref(props.post.podcast_atributes !== null && props.post.podcast_atributes !== undefined);
  //---------------------------------
  const { hasPaidAccount } = useUserAuth();
  //---------------------------------
  const { toggleAudio } = useAudioControl();
  //---------------------------------
  const { speed, isPlaying, isAnyLoading  } = useAudioPlayerState();
  //---------------------------------
  onBeforeUnmount(() => {
    unwatch();
  });
  //---------------------------------
  //Фокус на этом подкасте
  const isFocusTheAudio = computed(() => {
    return store.state.Audioplayer.activePodcastId == props.post.podcast_atributes?.id
  })
  //Подгружается лт это аудио
  const isLoadingTheAudio = computed(() => {
    return !isReady.value || (isFocusTheAudio.value && isAnyLoading.value)
  })
  //Проигрывается ли это аудио
  const isTheAudioPlaying = computed(() => {
    return isFocusTheAudio.value && isPlaying.value;
  })
  //---------------------------------
  //Добавить данные о подкасте в список стора
  const pushPodcastToStore = () => {
    store.dispatch('Audioplayer/addPodcastToList', props.post.podcast_atributes)
  };
  //Запусть подкаст
  const toActiveAudio = () => {
    if(!isReady.value || !props.post?.podcast_atributes?.id || !hasPaidAccount.value) return;
    toggleAudio(props.post.podcast_atributes.id);
  }
  //---------------------------
  const unwatch = watch(
    () => props.post.podcast_atributes,
    (newValue) => {
      if (newValue) {
        pushPodcastToStore();
        isReady.value = true;
        nextTick(() => unwatch());
      }
    },
    { flush: 'sync', immediate: true }
  );
  </script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>